import React, { useEffect, useState } from 'react';
import {
  deleteTrainingCenterAction,
  deleteTrainingCenterCourseAction,
  getSingleTrainingCenterAction,
  getTrainingCentersAction,
  switchTrainingCenterAction,
} from '../../../modules/trainingCenter/Actions';
import {
  currentTrainingCenterCourses,
  // supplierCategoriesListSelector,
  // isLoadingSelector,
  // searchValueSelector,
  // countSelector,
  trainingCenterAsListAndValue,
  trainingCenterCount,
  trainingCenterLoading,
  trainingCenterSearchValue,
} from '../../../modules/trainingCenter/Selectors';
import { connect } from 'react-redux';
import List from '../../../components/Lists/List';
import ListItem from '../../../components/Lists/ListItem';
import InfiniteScroll from 'react-infinite-scroll-component';
import { authCurrentDefaultTypeSelecetor } from '../../../modules/auth/Selectors';
import { Link, Route, Switch, useHistory, useParams } from 'react-router-dom';
import SubHeader from '../../../_psb/layout/sub-header/SubHeader';
import { id } from 'date-fns/locale';
const TrainingCenterCourseList = (props) => {
  const {
    // supplierCategories,
    // isLoading,
    // getSupplierCategories,
    // count,
    // searchValue,
    match,
    trainigCenter,
    count,
    isLoading,
    searchValue,
    getTrainingCenter,
    deteteTrainingCenter,
    defaultUserType,
    switchTrainingCenter,
    courses = [],
    getSingeTrainingCenter,
    deleteCourse,
  } = props;

  const [size, setSize] = useState(10);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const history = useHistory();

  // console.log(history);
  useEffect(() => {
    // getTrainingCenter({ size, offset, searchTerm: searchValue });
    getSingeTrainingCenter(match?.params?.id);
  }, [getSingeTrainingCenter, searchValue]);

  const fetchMore = () => {
    // set hasMore to false if the current items are >= the all items in database !
    if (trainigCenter.length >= count) {
      setHasMore(false);
      return false;
    }

    // otherwise get the data from the database
    getTrainingCenter({
      size,
      offset: trainigCenter.length,
      searchTerm: searchValue,
    });
  };

  //
  const dataLength =
    trainigCenter.length <= count ? trainigCenter.length : count;

  return (
    <>
      <SubHeader
        title="Training Center Courses List"
        Component={() => (
          <>
            {/* <Route
								exact
								path="/supplier-tags"
								component={() => {
									return (
										<>
											<span className="kt-subheader__separator kt-subheader__separator--v"></span>

											<Search
												searchValue={searchValue}
												setSearchValue={setSearchValue}
											/>
										</>
									);
								}}
							/> */}
          </>
        )}
      >
        <Switch>
          {/* <Route
            exact
            path="/training-center"
            component={() => (
              <Link to="/training-center/create" className="btn btn-primary">
                Add New{' '}
              </Link>
            )}
          /> */}
  
            <Route
              exact
              path="/training-center/:id/course"
              component={() => (
                <Link
                  to={`${history.location.pathname}/create`}
                  className="btn btn-primary"
                >
                  Add New{' '}
                </Link>
              )}
            />
 
        </Switch>
      </SubHeader>
      <InfiniteScroll
        dataLength={dataLength}
        hasMore={hasMore}
        next={fetchMore}
        style={{ overflow: 'hidden' }}
      >
        <div className="table row block--container my-5">
          <List
            header={{ items: ['Name'], actions: ['Edit'] }}
            isLoading={isLoading}
            items={courses}
          >
            <table className="table">
              <tbody>
                {courses.map(({ name, _id }) => (
                  <ListItem
                    key={_id}
                    name={name}
                    editLink={`${history.location.pathname}/${_id}`}
                    // enable={status}
                    // onSwich={() => {
                    //   switchTrainingCenter(_id, { status: !status });
                    // }}
                    // viewLink={`training-center/${_id}/course`}
                    onDelete={
                      defaultUserType === '0'
                        ? () => {
                            deleteCourse({
                              courseId: _id,
                              trainingCenterId: match?.params?.id,
                            });
                          }
                        : false
                    }
                  />
                ))}
              </tbody>
            </table>
          </List>
        </div>
      </InfiniteScroll>
    </>
  );
};

const mapStateToProps = (state) => ({
  // supplierCategories: supplierCategoriesListSelector(state),
  // isLoading: isLoadingSelector(state),
  // count: countSelector(state),
  // searchValue: searchValueSelector(state),
  trainigCenter: trainingCenterAsListAndValue(state),
  count: trainingCenterCount(state),
  isLoading: trainingCenterLoading(state),
  searchValue: trainingCenterSearchValue(state),
  defaultUserType: authCurrentDefaultTypeSelecetor(state),
  courses: currentTrainingCenterCourses(state),
});

export default connect(mapStateToProps, {
  // getSupplierCategories: getSupplierCategoriesAction,
  switchTrainingCenter: switchTrainingCenterAction,
  getTrainingCenter: getTrainingCentersAction,
  deteteTrainingCenter: deleteTrainingCenterAction,
  getSingeTrainingCenter: getSingleTrainingCenterAction,
  deleteCourse: deleteTrainingCenterCourseAction,
})(TrainingCenterCourseList);
